import { MANAGE_MASTER_PASSWORD } from './ApiConstants';
import api from './ApiHandler';

export const updateMasterPassword = async ({ password }: { password: String }) => {
  return await api.post(MANAGE_MASTER_PASSWORD, { password });
};
